var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "previoussummary",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalLabel",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          staticStyle: {
            "max-width": "780px",
            position: "fixed",
            "max-height": "85vh",
            "overflow-y": "auto",
            "margin-left": "-390px",
            left: "50%",
          },
          attrs: { role: "document", id: "MlListpopupContent" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(0),
            _c("div", { staticClass: "modal-body mt-0 pt-0" }, [
              _vm._m(1),
              _c(
                "div",
                { staticClass: "col-12" },
                _vm._l(
                  _vm.selected_previous_summary,
                  function (item, line_index) {
                    return _c(
                      "p",
                      {
                        key: _vm.prev_summary_arr_index + "_" + line_index,
                        style: { color: "grey" },
                        attrs: {
                          id:
                            "previous_summary_line_" +
                            _vm.prev_summary_arr_index +
                            "_" +
                            line_index,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.UseLine(
                              "previous_summary_line_" +
                                _vm.prev_summary_arr_index +
                                "_" +
                                line_index
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(item))]
                    )
                  }
                ),
                0
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        {
          staticClass:
            "modal-title text-center pull-left w-100 d-block mt-4 pb-0 mb-2 mb-0",
        },
        [_vm._v("Previous Summary ")]
      ),
      _c(
        "button",
        {
          staticClass: "close d-close",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", { staticClass: "text-info" }, [
        _vm._v("Notes: Click the content copy to Doctor summary"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }